<template>
  <div>
    <div v-for="token in tokens" :key="token.id">
      <div :ref="`token-${token.id}`" :id="`token-${token.id}`" class="selectableDiv" :style="getTokenStyle(token)">
      </div>
    </div>
  </div>
</template>

<script>
import DragSelect from 'dragselect';

export default {
  props: {
    propTokens: Array,
    isUsingLines: Boolean
  },
  data: () => ({
    tokens: [],
    ds: null,
    isDragOn: false,
  }),
  async mounted() {
    this.tokens = this.propTokens
    // Display html selectable elements
    const _this = this
    setTimeout(() => {
      _this.ds = new DragSelect({
        selectables: document.querySelectorAll('.selectableDiv'),
        area: document.getElementById('dragSelectAreaContainer'),
        overflowTolerance: { x: 25, y: 80 },
        autoScrollSpeed: 6,
        multiSelectMode: false,
        multiSelectToggling: false,
        draggability: false,
        keyboardDrag: false,
        dragKeys: { up:[], down:[], left:[], right:[] }
      });
      _this.ds.subscribe('callback', () => _this.onDragEnd())
      _this.ds.subscribe('dragstart', () => _this.onDragStart())
      _this.ds.subscribe('dragend', () => _this.onDragEnd())
      _this.ds.start()
    }, 1)
  },
  destroyed() {
    this.clearSelection()
    if (this.ds) {
      this.ds.unsubscribe('callback')
      this.ds.unsubscribe('dragend')
      this.ds.stop()
    }
  },
  methods: {
    disableShiftSelectionOfOutsideText() {
      // When drawing multiple rectangles with Shift key, some text all over the page is selected.
      // So we need to cancel shift selection mode of outside text during drag selection
      document.onselectstart = function() {
        return false;
      }
    },
    enableShiftSelectionOfOutsideText() {
      document.onselectstart = function() {
        return true;
      }
    },
    getTokenStyle(token) {
      const style = {
        'left': token.position.left * 100 + '%',
        'top': token.position.top * 100 + '%',
        'width': token.position.width * 100 + '%',
        'height': token.position.height * 100 + '%'
      }
      return style
    },
    onDragStart() {
      this.disableShiftSelectionOfOutsideText()
      this.isDragOn = true
    },
    onDragEnd() {
      this.enableShiftSelectionOfOutsideText()
      const tokenIds = Array(...document.querySelectorAll('.selectableDiv.ds-selected')).map(elt => {
        const idStr = elt.id.split('token-')[1]
        return this.isUsingLines ? idStr : parseInt(idStr)
      })
      this.$emit('passSelectedTokens', tokenIds)
      setTimeout(() => {
        this.isDragOn = false
      }, 1)
    },
    blurOfVueEditorForCopying() {
      // Triggered from parent component on blurOfVueEditorForCopying
      // Clear selection if dragSelect is not currently used
      if (!this.isDragOn) {
        this.clearSelection()
      }
    },
    clearSelection() {
      if (this.ds) this.ds.clearSelection()
      this.$emit('passSelectedTokens', [])
    }
  },
}
</script>

<style scoped>
.selectableDiv {
  position: absolute;
  display: flex;
  z-index: 1 !important;
  outline: 1px solid rgba(169, 169, 169, 0.474)
}

.ds-selected {
  outline: 1px solid blue
}

</style>